import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import LoginPage from "./pages/LoginPage";
import LessonsPage from "./pages/lessonsPage/LessonsPage";
import SubLesson from "./pages/lessonsPage/SubLessonPage";
import TutorialPage from "./pages/TutorialPage";
import PracticePage from "./pages/PracticePage";
import TestPage from "./pages/TestPage";
import HistoryPage from "./pages/HistoryPage";
import ComparePage from "./pages/ComparePage";
import ProfilePage from "./pages/profilePage/ProfilePage";
import ProfileEditPage from "./pages/profilePage/ProfileEditPage";
import FeedbackPage from "./pages/FeedbackPage";
import NotFoundPage from "./pages/404"; // Import your 404 page

import reportWebVitals from "./reportWebVitals";

// Bootstrap Libs
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

import { createBrowserRouter, RouterProvider } from "react-router-dom";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "login",
    element: <LoginPage />,
  },
  {
    path: "lessons",
    element: <LessonsPage />,
  },
  {
    path: "/sub-lesson/:lesson_id",
    element: <SubLesson />,
  },
  {
    path: "tutorial",
    element: <TutorialPage />,
  },
  {
    path: "practice",
    element: <PracticePage />,
  },
  {
    path: "test",
    element: <TestPage />,
  },
  {
    path: "compare",
    element: <ComparePage />,
  },
  {
    path: "history",
    element: <HistoryPage />,
  },
  {
    path: "profile",
    element: <ProfilePage />,
  },
  {
    path: "profile/edit",
    element: <ProfileEditPage />,
  },
  {
    path: "feedback",
    element: <FeedbackPage />,
  },
  {
    path: "*", // This catches all undefined routes
    element: <NotFoundPage />, // Use your imported 404 page here
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
